import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import notification from "common/utils/notification"
import i18next from "i18next"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'map-...
import mapKeysDeep from "map-keys-deep-lodash"
import CategoriaService from "../../services/CategoriaService"
import {
  addNode,
  deleteNode,
  findNode,
  modifyNode,
} from "../../utils/categoriasTreeUtils"
import { categoriasTreeObjSelector } from "../selectors/categoriasSelectors"

export const REPLACE_KEYS_TO_CATEGORIAS_PADRE = {
  children: "subCategorias",
  title: "nombre",
}

const replaceCategoriasKeysToSave = (categorias: $TSMigrationFixMe) =>
  mapKeysDeep(categorias, (_: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
    return REPLACE_KEYS_TO_CATEGORIAS_PADRE[key]
      ? // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        REPLACE_KEYS_TO_CATEGORIAS_PADRE[key]
      : key
  })

export const getAllCategoriasPadre = createAsyncThunk(
  "categorias/getAllCategoriasPadre",
  async () => {
    const categorias = await CategoriaService.getAllPadres()
    return categorias.data
  }
)

export const getAllCategorias = createAsyncThunk(
  "categorias/getAllCategorias",
  async () => {
    const categorias = await CategoriaService.getAll()
    return categorias.data
  }
)

export const createCategoria = createAsyncThunk(
  "categorias/create",
  async (categoria, thunkApi) => {
    const { data: categoriaData } = await CategoriaService.post(categoria)

    const categorias = categoriasTreeObjSelector(thunkApi.getState())

    const categoriasUpdated = addNode({
      categorias,
      // @ts-expect-error TS(2339): Property 'categoriaPadreId' does not exist on type...
      parentId: categoria?.categoriaPadreId,
      newNode: categoriaData,
    })

    await thunkApi.dispatch(getAllCategorias())
    return replaceCategoriasKeysToSave(categoriasUpdated?.treeData)
  }
)

export const updateCategoria = createAsyncThunk(
  "categorias/update",
  async (categoria, thunkApi) => {
    const { data: newCategoria } = await CategoriaService.put(categoria)

    const categorias = categoriasTreeObjSelector(thunkApi.getState())

    const categoriasUpdated = modifyNode({
      categorias,
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'void'.
      id: categoria.id,
      newNode: newCategoria,
    })

    await thunkApi.dispatch(getAllCategorias())
    return replaceCategoriasKeysToSave(categoriasUpdated?.treeData)
  }
)

export const deleteCategoria = createAsyncThunk(
  "categorias/delete",
  async (id, thunkApi) => {
    await CategoriaService.delete(id)

    const categorias = categoriasTreeObjSelector(thunkApi.getState())

    const nodeToDelete = findNode({ categorias, id })
    const newCategoriasTree = deleteNode({
      categorias,
      path: nodeToDelete?.path,
    })

    await thunkApi.dispatch(getAllCategorias())
    return replaceCategoriasKeysToSave(newCategoriasTree?.treeData)
  }
)

export const getCategoriaAndPosiblesPadres = createAsyncThunk(
  "categorias/fetchCategoriaData",
  async (categoriaId) => {
    const categoriaPromise = CategoriaService.getById(categoriaId)
    const posiblesPadresPromise =
      CategoriaService.getPosiblesCategoriasPadreByCategoriaId(categoriaId)

    const [categoria, posiblesPadres] = await Promise.all([
      categoriaPromise,
      posiblesPadresPromise,
    ])

    return {
      categoria: categoria.data,
      posiblesPadres: posiblesPadres.data,
    }
  }
)

export const categoriasSlice = createSlice({
  name: "categorias",
  initialState: {
    categoriasPadre: [],
    allCategorias: [],
    posiblesPadres: [],
    categoriaSelected: null,
    fetchingCategoriaData: false,
    fetchingCategorias: false,
    deletingCategoria: false,
    updatingCategoria: false,
    creatingCategoria: false,
    fetchingCategoriasByCatalogo: false,
  },
  reducers: {
    setCategorias: (state, { payload }) => {
      state.categoriasPadre = replaceCategoriasKeysToSave(payload)
    },
    selectCategoria: (state, { payload }) => {
      state.categoriaSelected = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategoriasPadre.pending, (state: $TSMigrationFixMe) => {
        state.fetchingCategorias = true
      })
      .addCase(getAllCategoriasPadre.rejected, (state: $TSMigrationFixMe) => {
        state.fetchingCategorias = false
      })
      .addCase(
        getAllCategoriasPadre.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.categoriasPadre = payload
          state.fetchingCategorias = false
        }
      )

      .addCase(
        getAllCategorias.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.allCategorias = payload
        }
      )

      .addCase(deleteCategoria.pending, (state: $TSMigrationFixMe) => {
        state.deletingCategoria = true
      })
      .addCase(
        deleteCategoria.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.deletingCategoria = false
          state.categoriaSelected = null
          state.categoriasPadre = payload
          notification.success({
            body: `${i18next.t("notification.categoryCorrectDelete")}`,
          })
        }
      )
      .addCase(deleteCategoria.rejected, (state: $TSMigrationFixMe) => {
        state.deletingCategoria = false
      })

      .addCase(updateCategoria.pending, (state: $TSMigrationFixMe) => {
        state.updatingCategoria = true
      })
      .addCase(
        updateCategoria.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.updatingCategoria = false
          state.categoriaSelected = null
          state.categoriasPadre = payload
          notification.success({
            body: `${i18next.t("notification.categoyCorrectModified")}`,
          })
        }
      )
      .addCase(updateCategoria.rejected, (state: $TSMigrationFixMe) => {
        state.updatingCategoria = false
      })

      .addCase(createCategoria.pending, (state: $TSMigrationFixMe) => {
        state.creatingCategoria = true
        state.categoriaCreated = false
      })
      .addCase(
        createCategoria.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.creatingCategoria = false
          state.categoriaCreated = true
          state.categoriasPadre = payload
          notification.success({
            body: `${i18next.t("notification.categoryCorrectCreated")}`,
          })
        }
      )
      .addCase(createCategoria.rejected, (state: $TSMigrationFixMe) => {
        state.creatingCategoria = false
        state.categoriaCreated = false
      })

      .addCase(
        getCategoriaAndPosiblesPadres.pending,
        (state: $TSMigrationFixMe) => {
          state.fetchingCategoriaData = true
        }
      )
      .addCase(
        getCategoriaAndPosiblesPadres.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.posiblesPadres = payload?.posiblesPadres
          state.categoriaSelected = payload?.categoria
          state.fetchingCategoriaData = false
        }
      )
      .addCase(
        getCategoriaAndPosiblesPadres.rejected,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.fetchingCategoriaData = false
          state.posiblesPadres = payload
        }
      )
  },
})

export const { setCategorias, selectCategoria } = categoriasSlice.actions
